import { levenshteinDistance } from "../common/levenshteinDistance";
import data from "../common/commonData.json"

/** 
 * check if word is too common given a word list
 * @param word to check in list
 * @param words list string to check
 * @param distance qty of diff between words checked
 */
export const isCommonWord = (word: string, words: string[], distance: number = 3): boolean => {
    if (word.length === 0) {
        return false
    }
    const mergeWords = [...words, ...data.commonWords]
    const isCommon = mergeWords.some(
        (wordItem: string) => levenshteinDistance(word, wordItem) <= distance
    );
    if (isCommon) {
        return true;
    }
    return false;
}